import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AppState {
  fullScreen: boolean
  windowResize: boolean
  loginResData: { token?: string }
  userInfo: UserInfo
  userRegionList: AreaData[]
  userResources: UserResources
  currentEntity: Entity
  currentArea: AreaData
  currentBiz: { businessType: BusinessType }
  entityIcon: string
  currentFence: {
    fenceId?: string | undefined
    selectFenceId?: string | undefined
  }
  entityConfigInfo: {
    brandList: BrandInfo[]
  }
  uiConfig: UICionfig
  collapsed: boolean
  controlConfig: {
    [key: string]: boolean
  }
}

const initialState: AppState = {
  fullScreen: false,
  windowResize: false,
  loginResData: {} as { token: string },
  userInfo: {} as UserInfo,
  userRegionList: [] as AreaData[],
  userResources: [] as UserResources,
  currentEntity: {} as Entity,
  currentArea: {} as AreaData,
  currentBiz: {} as { businessType: BusinessType },
  entityIcon: '',
  currentFence: {},
  entityConfigInfo: {
    brandList: [],
  },
  uiConfig: {
    menuBarLayout: null,
    sidebarColor: null,
    chartLayout: null,
    subjectColor: '',
    mapBackgroundColor: '',
    loginPagePicture: null,
    loginPageLayout: '',
    loginPageColor: '',
    loginPageTitle: '',
    loginPageSubTitle: '',
    resourceLayOutMap: '',
  },
  collapsed: false,
  controlConfig: {},
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    loginResData: (state, action: PayloadAction<{ token: string }>) => {
      state.loginResData = action.payload
    },
    userInfo: (state, action) => {
      state.userInfo = action.payload
    },
    userResources: (state, action) => {
      state.userResources = action.payload
    },
    currentEntity: (state, action: PayloadAction<Entity>) => {
      state.currentEntity = action.payload
    },
    currentArea: (state, action: PayloadAction<AreaData>) => {
      state.currentArea = action.payload
    },
    currentFence: (state, action: PayloadAction<AppState['currentFence']>) => {
      state.currentFence = { ...state.currentFence, ...action.payload }
    },
    currentBiz: (state, action: PayloadAction<{ businessType: BusinessType }>) => {
      state.currentBiz = action.payload
    },
    entityIcon: (state, action: PayloadAction<string>) => {
      state.entityIcon = action.payload
    },
    windowResize: state => {
      state.windowResize = !state.windowResize
    },
    updateFullScreen: (state, action: PayloadAction<boolean>) => {
      state.fullScreen = action.payload
    },
    updateEntityConfigInfo: (state, action: PayloadAction<AppState['entityConfigInfo']>) => {
      state.entityConfigInfo = { ...state.entityConfigInfo, ...action.payload }
    },
    updateUIConfig: (state, action: PayloadAction<UICionfig>) => {
      state.uiConfig = action.payload
    },
    updateCollapsed: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload
    },
    updateControlConfig: (state, action: PayloadAction<AppState['controlConfig']>) => {
      state.controlConfig = { ...state.controlConfig, ...action.payload }
    },
    userRegionList: (state, action: PayloadAction<AreaData[]>) => {
      state.userRegionList = action.payload
    },
  },
})

export const {
  loginResData,
  userInfo,
  userResources,
  currentEntity,
  entityIcon,
  currentArea,
  currentBiz,
  currentFence,
  windowResize,
  updateFullScreen,
  updateEntityConfigInfo,
  updateUIConfig,
  updateCollapsed,
  updateControlConfig,
  userRegionList,
} = appSlice.actions

export default appSlice.reducer
